// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1440": "e3543217a864","494": "4077578422d4","7460": "da36e702c31d","9750": "e65fe83f1597",}[chunkId] + ".css"
}